import React, { Component } from 'react';
import {Route, Switch} from "react-router-dom";
import userManager from './userManager';
import Layout from "./components/Layout";
import Callback from "./components/Callback";
import WorkOrderList from "./components/WorkOrder/WorkOrderList";
import WorkOrderDetail from "./components/WorkOrder/WorkOrderDetail";
import Page404 from "./components/404";
import {connect} from "react-redux";
import HomePage from "./components/Home";
import InvoiceList from "./components/Invoice/InvoiceList";
import LocationList from "./components/Location/LocationList";
import LocationDetail from "./components/Location/LocationDetail";
import QuoteList from "./components/Quote/QuoteList";
import Document from "./components/Document";
import Logout from "./components/Logout";
import Admin from "./components/Admin/Admin";
import KPI from "./components/KPI/BaseLayout";


class CustomRouter extends Component {
  
  render(){

    // wait for user to be loaded, and location is known
    if (this.props.isLoadingUser || !this.props.location) {
      return null;
    }

    // if location is callback page, return only CallbackPage route to allow signin process
    if (this.props.location.pathname === '/callback') {
      return <Route path='/callback' component={Callback} />
    }
    
    // Allow user to see the home page, if they try to go anywhere else, redirect them to log in
    if (this.props.location.pathname === '/') {
      return (
        <Layout>
          <Route path='/' component={HomePage} />
        </Layout>
      );
    }
    // check if user is signed in
    userManager.getUser().then(user => {
      if ((!user || user.expired) && !this.props.isLoggingOut) {
        console.log("redirecting...");
        // if no user found, or token has expired, auto redirect to identity server signin page
        // pass the current path to redirect to the correct page after successfull login
        userManager.signinRedirect({data: {path: window.location.pathname}});
        return null;
      }
    });
    
    // wait for userManager to load the user
    if (!this.props.user)
      return null;

    if (this.props.location.pathname.split('/')[1] === 'document') {
      console.log('document');
      return <Route path='/document' component={Document}/>
    }
    
    return(
      <Layout>
        <Switch>
          <Route path='/home' component={HomePage}/>
          <Route path='/dashboard' component={KPI}/>
          <Route exact path='/services' component={WorkOrderList}/>
          <Route exact path='/services/:id' component={WorkOrderDetail}/>
          <Route path='/invoices' component={InvoiceList}/>
          <Route exact path='/locations' component={LocationList}/>
          <Route exact path='/locations/:id' component={LocationDetail}/>
          <Route path='/quotes' component={QuoteList}/>
          <Route path='/logout' component={Logout}/>
          {this.props.user.profile.cf_cdb_admin === 'true' ? <Route exact path='/admin' component={Admin}/> : ''}
          <Route component={Page404}/>
        </Switch>
      </Layout>);
  }
}

function mapStateToProps(state, ownProps){
  return {
    user: state.oidc.user,
    isLoadingUser: state.oidc.isLoadingUser,
    isLoggingOut: state.boolLogout.isLoggingOut,
    path: ownProps.path,
    component: ownProps.component
  };
}

function mapDispatchToProps(dispatch){
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomRouter);